 
import { OperationType, ROUTE_PATH } from 'common/constants/sm-constants';
import { DataModel, MetaModel } from '../utility-models/base-model';
import {  menuItem } from 'common/models/utility-models/utility-interface';
 
export class SidebarModel extends DataModel {
  isSidebarOpen: boolean = true;
  showLabel: boolean = false;
  sidebarItems: (menuItem)[] = [
    {
      id: 1,
      menuItem: 'Notifications',
      filePath: 'announcement-icon',
      activePath: 'announcement-color-icon',
      slug: 'notificationgrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 1,
      status: null,
      roleAccess: [1,4] ,
    },

    {
      id: 2,
      menuItem: 'Dashboard',
      filePath: 'dashboard-icon',
      activePath: 'student-color-icon',
      slug: 'adminDashboard',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 2,
      status: null,
      roleAccess:[1,4],
    },
    {
      id: 14,
      menuItem: 'Your Profile',
      filePath: 'student-icon',
      activePath: 'active',
      slug: 'student_profile',
      operationType: OperationType.UPDATE,
      showLabel: true,
      priority: 14,
      status: 1,
      roleAccess: [2],
    },
    {
      id: 14,
      menuItem: 'Your Profile',
      filePath: 'student-icon',
      activePath: 'active',
      slug: 'student_profile',
      operationType: OperationType.UPDATE,
      showLabel: true,
      priority: 14,
      status: 3,
      roleAccess: [2],
    },
    // {
    //   id: 24 ,
    //   menuItem: 'SSP Hub',
    //   filePath: 'ssp-hub-icon',
    //   activePath: 'active',
    //   slug: 'ssphub',
    //   operationType: OperationType.VIEW,
    //   showLabel: true,
    //   priority: 14,
    //   status: null,
    //   roleAccess: [1,2,4],
    // },
    {
      id: 24 ,
      menuItem: 'Notifications',
      filePath: 'announcement-icon',
      activePath: 'active',
      slug: 'studentNotificationGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 14,
      status: 1,
      roleAccess: [2],
    },
    {
      id: 20 ,
      menuItem: 'Assignment',
      filePath: 'assignments-icon',
      activePath: 'active',
      slug: 'studentAssignment',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 14,
      status: 1,
      roleAccess: [2],
    },

    {
      id: 21 ,
      menuItem: 'Internship',
      filePath: 'internship-icon',
      activePath: 'active',
      slug: 'studentInternship',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 14,
      status: 1,
      roleAccess: [2],
    },
    {
      id: 2,
      menuItem: 'Applicants',
      filePath: 'applicants-icon',
      activePath: 'student-color-icon',
      slug: 'applicants',
      operationType: OperationType.MULTIUTILITY,
      showLabel: true,
      priority: 2,
      status: null,
      roleAccess:[1,4],
    },
    {
      id: 3,
      menuItem: 'Students',
      filePath: 'student-icon',
      activePath: 'active',
      slug: 'studentsGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 3,
      status: null,
      roleAccess: [1,4],
    },
 
    {
      id: 3,
      menuItem: 'KT Logs',
      filePath: 'ktlogs-icon',
      activePath: 'active',
      slug: 'ktlogs',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 3,
      status: null,
      roleAccess: [1,4],
    },
 
    {
      id: 4,
      menuItem: 'Users',
      filePath: 'user-icon',
      activePath: 'active',
      slug: 'userGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 4,
      status: null,
      roleAccess: [1,4],
    },
    {
      id: 5,
      menuItem: 'Trainers',
      filePath: 'trainer-icon',
      activePath: 'active',
      slug: 'trainersGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 5,
      status: null,
      roleAccess: [1,4],
    },
    {
      id: 7,
      menuItem: 'Assignments',
      filePath: 'assignments-icon',
      activePath: 'active',
      slug: 'assignmentGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 7,
      status: null,
      roleAccess: [1,4],
    },
 
    {
      id: 14,
      menuItem: 'Credit',
      filePath: 'ktlogs-icon',
      activePath: 'active',
      slug: 'credit',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 13,
      status: null,
      roleAccess: [1,4],
    },
 
    {
      id: 14,
      menuItem: 'Internship',
      filePath: 'internship-icon',
      activePath: 'active',
      slug: 'studentListData',
      operationType: OperationType.MULTIUTILITY,
      showLabel: true,
      priority: 13,
      status: null,
      roleAccess: [1,4],
      isDropdown: true,
      dropdownItems:[
        {
          id: 14,
          menuItem: 'Internship',
          filePath: 'internship-icon',
          activePath: 'active',
          slug: 'internship',
          operationType: OperationType.MULTIUTILITY,
          showLabel: true,
          priority: 13,
          status: null,
          roleAccess: [1,4],
        },
        {
          id: 11,
          menuItem: 'Internship Company',
          filePath: 'company-icon',
          activePath: 'active',
          slug: 'internshipComapny',
          operationType: OperationType.VIEW,
          showLabel: true,
          priority: 11,
          status: null,
          roleAccess: [1,4],
        },
      ]
    },
 
    {
      id: 16,
      menuItem: 'Email Template',
      filePath: 'email-white-icon',
      activePath: 'active',
      slug: 'templateGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 16,
      status: null,
      roleAccess: [1,4],
    },
    {
      id: 7,
      menuItem: 'Types',
      filePath: 'category-icon',
      activePath: 'active',
      slug: 'typeGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 7,
      status: null,
      roleAccess: [1,4],
    },
 
    {
      id: 6,
      menuItem: 'Locations',
      filePath: 'location-icon',
      activePath: 'active',
      slug: 'locationGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 7,
      status: null,
      roleAccess: [1,4],
    },
    {
      id: 8,
      menuItem: 'Batch',
      filePath: 'batch-icon',
      activePath: 'active',
      slug: 'batchesGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 8,
      status: null,
      roleAccess: [1,4],
    },
    {
      id: 9,
      menuItem: 'Groups',
      filePath: 'group-icon',
      activePath: 'active',
      slug: 'groups',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 9,
      status: null,
      roleAccess: [1,4],
    },
    {
      id: 12,
      menuItem: 'Branch',
      filePath: 'branch-icon',
      activePath: 'active',
      slug: 'branchGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 12,
      status: null,
      roleAccess: [1,4],
      isDropdown: true,
      dropdownItems:[
        {
          id: 12,
          menuItem: 'Branch',
          filePath: 'branch-icon',
          activePath: 'active',
          slug: 'branchGrid',
          operationType: OperationType.VIEW,
          showLabel: true,
          priority: 12,
          status: null,
          roleAccess: [1,4],
        },
        {
          id: 10,
          menuItem: 'Branch Category',
          filePath: 'branch-category-icon',
          activePath: 'active',
          slug: 'branchCategory',
          operationType: OperationType.VIEW,
          showLabel: true,
          priority: 10,
          status: null,
          roleAccess: [1,4],
        },
      ]
    },
 
 
 
    
    // {
    //   id: 14,
    //   menuItem: 'Your Profile',
    //   filePath: 'student-icon',
    //   activePath: 'active',
    //   slug: 'student_profile',
    //   operationType: OperationType.UPDATE,
    //   showLabel: true,
    //   priority: 14,
    //   status: 3,
    //   roleAccess: [2],
    // },
 
    
   
    {
      id: 15,
      menuItem: 'Reimbursement',
      filePath: 'reimbursement-icon',
      activePath: 'active',
      slug: 'admintravelReimbursement',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 13,
      status: null,
      roleAccess: [1,4],
    },
 
    {
      id: 13,
      menuItem: 'Reports',
      filePath: 'reports-icon',
      activePath: 'active',
      slug: 'reports',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 13,
      status: null,
      roleAccess: [1,4],
    },
   
 
    {
      id: 14,
      menuItem: 'Mentors',
      filePath: 'mentor-icon',
      activePath: 'active',
      slug: 'mentorList',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 15,
      status: null,
      roleAccess: [1, 4],
      isDropdown: true,
      dropdownItems:[
 
        {
          id: 14,
          menuItem: 'Mentors',
          filePath: 'mentor-icon',
          activePath: 'active',
          slug: 'mentorList',
          operationType: OperationType.VIEW,
          showLabel: true,
          priority: 15,
          status: null,
          roleAccess: [1, 4],
        },
        {
          id: 15,
          menuItem: 'Mentor Mapping',
          filePath: 'mentor-mapping-icon',
          activePath: 'active',
          slug: 'mentorMappingList',
          operationType: OperationType.VIEW,
          showLabel: true,
          priority: 15,
          status: null,
          roleAccess: [1, 4],
        },
        {
          id: 15,
          menuItem: 'Mentor Logs',
          filePath: 'mentor-logs-icon',
          activePath: 'active',
          slug: 'mentorLogs',
          operationType: OperationType.VIEW,
          showLabel: true,
          priority: 15,
          status: null,
          roleAccess: [1, 4],
        },
      ]
    },

    {
      id: 15,
      menuItem: 'Feedback',
      filePath: 'feedback-icon',
      activePath: 'active',
      slug: 'feedbackGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 13,
      status: null,
      roleAccess: [1,4],
      isDropdown: true,
      dropdownItems:[
        {
          id: 15,
          menuItem: 'Feedback',
          filePath: 'feedback-icon',
          activePath: 'active',
          slug: 'feedbackGrid',
          operationType: OperationType.VIEW,
          showLabel: true,
          priority: 13,
          status: null,
          roleAccess: [1,4],
        },
        {
          id: 18,
          menuItem: 'Feedback Mapping',
          filePath: 'feedback-mapping-icon',
          activePath: 'active',
          slug: 'feedbackMappinggrid',
          operationType: OperationType.VIEW,
          showLabel: true,
          priority: 18,
          status: null,
          roleAccess: [1,4],
        },
      ]
    },
    // {
    //   id: 14,
    //   menuItem: 'Internship List',
    //   filePath: 'ussideer-icon',
    //   activePath: 'active',
    //   slug: 'internshipList',
    //   operationType: OperationType.MULTIUTILITY,
    //   showLabel: true,
    //   priority: 13,
    //   status: null,
    //   roleAccess: [1],
    // },
   
    // {
    //   id: 14,
    //   menuItem: 'Credit',
    //   filePath: 'user-icon',
    //   activePath: 'active',
    //   slug: 'credit',
    //   operationType: OperationType.VIEW,
    //   showLabel: true,
    //   priority: 13,
    //   status: null,
    //   roleAccess: ['1','4'],
    // },
    // {
    //   id: 14,
    //   menuItem: 'Internship',
    //   filePath: 'user-icon',
    //   activePath: 'active',
    //   slug: 'studentListData',
    //   operationType: OperationType.MULTIUTILITY,
    //   showLabel: true,
    //   priority: 13,
    //   status: null,
    //   roleAccess: [1],
    // },
    // {
    //   id: 14,
    //   menuItem: 'Credit',
    //   filePath: 'user-icon',
    //   activePath: 'active',
    //   slug: 'credit',
    //   operationType: OperationType.VIEW,
    //   showLabel: true,
    //   priority: 13,
    //   status: null,
    //   roleAccess: ['1','4'],
    // },
    {
      id: 15,
      menuItem: 'Travel Reimbursement',
      filePath: 'travel-icon',
      activePath: 'active',
      slug: 'travelReimbursement',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 14,
      status: 1,
      roleAccess:[2],
    },

    {
      id: 18,
      menuItem: 'Feedback',
      filePath: 'feedback-icon',
      activePath: 'active',
      slug: 'studentFeedbackGrid',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 14,
      status: 1,
      roleAccess: [2],
    },
    {
      id: 15,
      menuItem: 'Mentoring Document',
      filePath: 'travel-icon',
      activePath: 'active',
      slug: 'mentoringDocument',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 14,
      status: 1,
      roleAccess: [2],
    },
    // {
    //   id: 17,
    //   menuItem: 'Register',
    //   filePath: 'email-white-icon',
    //   activePath: 'active',
    //   slug: 'register',
    //   operationType: OperationType.CREATE,
    //   showLabel: true,
    //   priority: 17,
    //   status: null,
    //   roleAccess: [1],
    // },
    //SSP Hub
 
   
 
 
    
    {
      id: 21,
      menuItem: 'Your Profile',
      filePath: 'trainer-icon',
      activePath: 'active',
      slug: 'trainersStudentForm',
      operationType: OperationType.UPDATE,
      showLabel: true,
      priority: 15,
      status: 1,
      roleAccess: [3],
    },
 
    {
      id: 22,
      menuItem: 'Your Profile',
      filePath: 'trainer-icon',
      activePath: 'active',
      slug: 'alumniForm',
      operationType: OperationType.CREATE,
      showLabel: true,
      priority: 16,
      status: 2,
      roleAccess: [2],
    },
 
 
    
 
   
    // {
    //   id: 22 ,
    //   menuItem: 'Upload Document',
    //   filePath: 'user-icon',
    //   activePath: 'active',
    //   slug: 'uploadDocument',
    //   operationType: OperationType.UPDATE,
    //   showLabel: true,
    //   priority: 14,
    //   status: null,
    //   roleAccess: [1],
    // },
   
    {
      id: 2,
      menuItem: 'Email Logs',
      filePath: 'email-logs-icon',
      activePath: 'student-color-icon',
      slug: 'emailLogsList',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 2,
      status: null,
      roleAccess:[1,4],
    },
 
 
 
    {
      id: 23 ,
      menuItem: 'Assignment',
      filePath: 'user-icon',
      activePath: 'active',
      slug: 'studentTrainerAssignment',
      operationType: OperationType.VIEW,
      showLabel: true,
      priority: 14,
      status: null,
      roleAccess: [3],
    },
   
 
    
 
 
 
    // {
    //   id: 24 ,
    //   menuItem: 'intership list',
    //   filePath: 'announcement-icon',
    //   activePath: 'active',
    //   slug: 'intershipGrid',
    //   operationType: OperationType.VIEW,
    //   showLabel: true,
    //   priority: 14,
    //   status: null,
    //   roleAccess: ['1'],
    // },
 
    // {
    //   id: 24 ,
    //   menuItem: 'intership list',
    //   filePath: 'announcement-icon',
    //   activePath: 'active',
    //   slug: 'intershipDetails',
    //   operationType: OperationType.VIEW,
    //   showLabel: true,
    //   priority: 14,
    //   status: null,
    //   roleAccess: ['1'],
    // },
 
    // {
    //   id: 25 ,
    //   menuItem: 'Add intership',
    //   filePath: 'announcement-icon',
    //   activePath: 'active',
    //   slug: 'AddInternship',
    //   operationType: OperationType.CREATE,
    //   showLabel: true,
    //   priority: 14,
    //   status: null,
    //   roleAccess: ['1'],
    // },
 
    // {
    //   id: 24 ,
    //   menuItem: 'App Management',
    //   filePath: 'email-white-icon',      
    //   activePath: 'active',
    //   slug: 'appVersion',
    //   operationType: OperationType.VIEW,
    //   showLabel: true,
    //   priority: 14,
    //   status: 1,
    //   roleAccess: [1,4],
    // },
 
 
 
 
  ];
}
 
export class SidebarMetaModel extends MetaModel {
  getMetaModel() {
    const props = {
      pageTitle: 'Sidebar',
      redirectPath: '',
      properties: '',
    };
    return props;
  }
}
 
 
 
 